/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment.development';
import { enableProdMode } from '@angular/core';

if (environment.production) {
  enableProdMode();
  // Disable all console methods in production
  // console.log = function (): void { };
  // console.warn = function (): void { };
  // console.error = function (): void { };
  // console.info = function (): void { };
  // console.debug = function (): void { };
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));

  // // "postbuild": "node postbuild.js"
